const cartData = [
  {
    id: 1,
    name: "tropical-fruits",
    header: "Tropical Fruits",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Mangoes", "Papayas", "Pineapples", "Guavas"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Rich in vitamin A, C, and enzymes like papain (papaya) and bromelain (pineapple)",
          "Aid digestion and reduce inflammation",
          "Provide energy and immune support",
          "High in fiber and natural sugars for quick fuel",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Fruit of the month: Tropical fruits",
            body: "https://www.health.harvard.edu/heart-health/fruit-of-the-month-tropical-fruits",
          },
          {
            head: "Why Papaya Is So Good for You, According to Nutrition Experts",
            body: "https://www.realsimple.com/health-benefits-of-papaya-11742557",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "berries",
    header: "Berries",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Blueberries", "Strawberries", "Raspberries", "Blackberries"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "High in antioxidants (like anthocyanins)",
          "Rich in vitamin C, fiber, and folate",
          "Help improve heart health and brain function",
          "Low in sugar and calories",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Berries are among the healthiest foods you can eat",
            body: "https://hsph.harvard.edu/news/fresh-berries-are-among-the-healthiest-foods-you-can-eat/",
          },
          {
            head: "Eat these fruits for their anti-inflammatory benefits",
            body: "https://www.health.harvard.edu/nutrition/eat-these-fruits-for-their-anti-inflammatory-benefits",
          },
          {
            head: "Eat blueberries and strawberries three times per week",
            body: "https://www.health.harvard.edu/heart-health/eat-blueberries-and-strawberries-three-times-per-week",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "citrus-fruits",
    header: "Citrus Fruits",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Oranges", "Lemons", "Limes", "Grapefruits"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Excellent source of vitamin C",
          "Support immune function and skin health",
          "Provide potassium, fiber, and flavonoids",
          "May reduce risk of kidney stones and improve iron absorption",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "The Powerful Health Benefits of Citrus Fruits",
            body: "https://thewholeu.uw.edu/2022/05/23/citrus/",
          },
          {
            head: "Eat these fruits for their anti-inflammatory benefits",
            body: "https://www.health.harvard.edu/nutrition/eat-these-fruits-for-their-anti-inflammatory-benefits",
          },
        ],
      },
    ],
  },

  {
    id: 4,
    name: "cruciferous-vegetables",
    header: "Cruciferous Vegetables",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Broccoli",
          "Cauliflower",
          "Cabbage",
          "Brussels Sprouts",
          "Kale",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Rich in vitamins C, K, and folate",
          "High in fiber and sulforaphane, a plant compound that may fight cancer",
          "Support detoxification and hormonal balance",
          "Promote heart and bone health",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "About Cruciferous Vegetables",
            body: "https://lpi.oregonstate.edu/mic/food-beverages/cruciferous-vegetables",
          },
          {
            head: "7 foods to fight cancer, heart disease and enhance health",
            body: "https://news.llu.edu/patient-care/7-foods-fight-cancer-heart-disease-and-enhance-health",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "leafy-greens",
    header: "Leafy Greens",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Spinach",
          "Swiss Chard",
          "Collard Greens",
          "Lettuce",
          "Arugula",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Packed with iron, calcium, magnesium, and vitamins A, C, and K",
          "Excellent for eye health, blood clotting, and immune support",
          "Low in calories, high in antioxidants",
          "Promote healthy digestion and reduced inflammation",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Salad greens: Getting the most bang for the bite",
            body: "https://www.health.harvard.edu/staying-healthy/salad-greens-getting-the-most-bang-for-the-bite",
          },
          {
            head: "Filling up on Healthy Leafy Greens",
            body: "https://capemay.njaes.rutgers.edu/2023/01/26/filling-up-on-healthy-leafy-greens/",
          },
          {
            head: "Spring Greens!",
            body: "https://www.nutritionletter.tufts.edu/general-nutrition/spring-greens/",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: "root-vegetables",
    header: "Root Vegetables",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Carrots", "Sweet Potatoes", "Beets", "Turnips", "Radishes"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Great source of fiber, potassium, and complex carbohydrates",
          "Rich in beta-carotene (carrots, sweet potatoes), which supports vision and immunity",
          "Provide natural energy and help stabilize blood sugar",
          "Contain antioxidants that support liver and brain health",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "All about Root Vegetables!",
            body: "https://cns.ucdavis.edu/news/all-about-root-vegetables",
          },
          {
            head: "The pros and cons of root vegetables",
            body: "https://www.health.harvard.edu/staying-healthy/the-pros-and-cons-of-root-vegetables",
          },
        ],
      },
    ],
  },
  {
    id: 7,
    name: "whole-grains",
    header: "Whole Grains",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Brown Rice", "Oats", "Quinoa", "Whole Wheat", "Barley"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "High in fiber, B vitamins, iron, magnesium, and antioxidants",
          "Support digestive health and help regulate blood sugar",
          "Promote heart health by lowering cholesterol",
          "Provide long-lasting energy for active bodies",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Whole Grains",
            body: "https://nutritionsource.hsph.harvard.edu/what-should-you-eat/whole-grains/",
          },
          {
            head: "Why Eat Whole Grains?",
            body: "https://extension.psu.edu/why-eat-whole-grains",
          },
          {
            head: "Whole grains may benefit your heart and lengthen your life",
            body: "https://www.health.harvard.edu/press_releases/whole-grains-may-benefit-your-heart-and-lengthen-your-life",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    name: "ancient-grains",
    header: "Ancient Grains",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Quinoa", "Farro", "Amaranth", "Millet", "Teff"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Naturally gluten-free options (like quinoa, amaranth, teff)",
          "Packed with protein, fiber, and minerals like iron and zinc",
          "Support muscle repair and immune health",
          "Offer unique flavors and textures for variety in meals",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Go with the Grain: Ancient Alternatives for a Healthier Heart",
            body: "https://thewholeu.uw.edu/2017/02/08/since-way-back-ancient-grains-are-a-heart-healthy-alternative/",
          },
          {
            head: "An Ancient Appeal",
            body: "https://u.osu.edu/livehealthyosu/2023/07/13/an-ancient-appeal/",
          },
        ],
      },
    ],
  },
  {
    id: 9,
    name: "sprouted-grains",
    header: "Sprouted Grains",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Sprouted Wheat", "Sprouted Barley", "Sprouted Brown Rice"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Easier to digest and may increase nutrient absorption",
          "Higher in certain amino acids and enzymes",
          "May improve gut health and reduce inflammation",
          "Often used in sprouted grain breads, a more nutritious option than refined white bread",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Are sprouted grains more nutritious than regular whole grains?",
            body: "https://www.health.harvard.edu/blog/sprouted-grains-nutritious-regular-whole-grains-2017110612692",
          },
          {
            head: "Baking and Cooking with Grains other than Wheat",
            body: "https://foodlab.nutrition.tufts.edu/baking-and-cooking-with-other-grains/",
          },
        ],
      },
    ],
  },
  {
    id: 10,
    name: "milk-based-fats",
    header: "Milk Based Fats",
    data: [
      {
        type: "heading",
        dataHeader: "Milk and Milk Alternatives",
        content: "Milk and Milk Alternatives",
      },
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Cow Milk",
          "Goat Milk",
          "Soy Milk",
          "Almond Milk",
          "Oat Milk",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Rich in calcium, vitamin D, protein, and B12",
          "Supports bone growth, nerve function, and muscle health",
          "Fortified plant-based milks can offer similar nutrients for those who are lactose intolerant or vegan",
          "Great for hydration and recovery after physical activity",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Nutrition and Plant-Based Milk Substitutes",
            body: "https://www.nutritionletter.tufts.edu/healthy-eating/nutrition-and-plant-based-milk-substitutes/",
          },
          {
            head: "About Milk",
            body: "https://nutritionsource.hsph.harvard.edu/milk/",
          },
          {
            head: "Dairy vs. Plant-Based Milks: Which is the Healthiest Option?",
            body: "https://lifestylemedicine.stanford.edu/dairy-soy-almond-oat-hemp-milk/",
          },
        ],
      },
      {
        type: "heading",
        dataHeader: "Cheese",
        content: "Cheese",
      },
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Cheddar", "Mozzarella", "Feta", "Cottage Cheese"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "High in calcium, protein, and phosphorus",
          "Supports strong bones and teeth",
          "Cottage cheese is especially high in casein protein, great for muscle repair",
          "A flavorful source of fat and protein in small servings",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "About Cheese",
            body: "https://nutritionsource.hsph.harvard.edu/cheese/",
          },
          {
            head: "Dairy: Health food or health risk?",
            body: "https://www.health.harvard.edu/blog/dairy-health-food-or-health-risk-2019012515849",
          },
          {
            head: "Selecting Cheese for Health",
            body: "https://extension.psu.edu/selecting-cheese-for-health",
          },
          {
            head: "What's the deal with dairy and heart health?",
            body: "https://www.health.harvard.edu/heart-health/whats-the-deal-with-dairy-and-heart-health",
          },
        ],
      },
      {
        type: "heading",
        dataHeader: "Yogurt and Fermented Dairy",
        content: "Yogurt and Fermented Dairy",
      },
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Yogurt", "Greek Yogurt", "Kefir", "Skyr"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Rich in probiotics that support gut health and digestion",
          "Excellent source of calcium, protein, and B vitamins",
          "Greek yogurt has higher protein and lower sugar",
          "Kefir offers both probiotics and is often easier to digest for those sensitive to lactose",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Yogurt, Kefir and Other Choices at the Supermarket",
            body: "https://publications.extension.uconn.edu/publication/yogurt-kefir/",
          },
          {
            head: "About Yogurt",
            body: "https://nutritionsource.hsph.harvard.edu/food-features/yogurt/",
          },
          {
            head: "The benefits of probiotics bacteria",
            body: "https://www.health.harvard.edu/staying-healthy/the-benefits-of-probiotics",
          },
          {
            head: "How do the nutrition and probiotic benefits of kefir compare with those of Greek yogurt?",
            body: "https://www.nutritionletter.tufts.edu/general-nutrition/q-how-do-the-nutrition-and-probiotic-benefits-of-kefir-compare-with-those-of-greek-yogurt/",
          },
        ],
      },
    ],
  },
  {
    id: 11,
    name: "animal-based-proteins",
    header: "Animal-Based Proteins",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: ["Chicken", "Turkey", "Beef", "Pork", "Fish", "Eggs"],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "High in complete proteins (contain all 9 essential amino acids)",
          "Rich in iron, zinc, vitamin B12, and omega-3s (in fatty fish)",
          "Supports muscle growth, immune function, and brain development",
          "Eggs are a nutrient-dense, affordable protein for all ages",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Comparative Health Impacts of Animal and Plant Proteins: An Exploration of Cardiovascular Risks and Benefits",
            body: "https://www.academia.edu/128542702/Comparative_Health_Impacts_of_Animal_and_Plant_Proteins_An_Exploration_of_Cardiovascular_Risks_and_Benefits",
          },
          {
            head: "Immunity In Brief",
            body: "https://lpi.oregonstate.edu/mic/health-disease/immunity-in-brief",
          },
        ],
      },
    ],
  },
  {
    id: 12,
    name: "plant-based-proteins",
    header: "Plant-Based Proteins",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Beans",
          "Lentils",
          "Tofu",
          "Tempeh",
          "Edamame",
          "Chickpeas",
          "Peas",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "High in fiber, iron, magnesium, and folate",
          "Lower in saturated fat and often more sustainable",
          "Help support heart health, digestive health, and stable energy",
          "Combining grains and legumes (like rice and beans) forms a complete protein",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "High-protein foods: The best protein sources to include in a healthy diet",
            body: "https://www.health.harvard.edu/nutrition/high-protein-foods-the-best-protein-sources-to-include-in-a-healthy-diet",
          },
          {
            head: "What is a plant-based diet and why should you try it?",
            body: "https://www.health.harvard.edu/blog/what-is-a-plant-based-diet-and-why-should-you-try-it-2018092614760",
          },
          {
            head: "Eat more plants, fewer animals",
            body: "https://www.health.harvard.edu/blog/eat-more-plants-fewer-animals-2018112915198",
          },
        ],
      },
    ],
  },
  {
    id: 13,
    name: "nuts-seeds-butters",
    header: "Nuts, Seeds, and Their Butters",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Almonds",
          "Peanuts",
          "Sunflower Seeds",
          "Chia Seeds",
          "Flaxseeds",
          "Peanut Butter",
          "Tahini",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients & Benefits",
        content: [
          "Contain healthy fats, protein, vitamin E, and magnesium",
          "Support brain function, heart health, and satiety",
          "Great plant-based protein snack options",
          "Chia and flaxseeds are also high in omega-3s",
        ],
      },

      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "About Almonds",
            body: "https://nutritionsource.hsph.harvard.edu/food-features/almonds/",
          },

          {
            head: "Peanuts linked to same heart, longevity benefits as more pricey nuts",
            body: "https://www.health.harvard.edu/blog/peanuts-linked-heart-longevity-benefits-pricey-nuts-201503057777",
          },

          {
            head: "Is Salted Peanuts Good for Weight Loss? Here's What You Need to Know",
            body: "https://blog.umd.edu/yummy/is-salted-peanuts-good-for-weight-loss-heres-what-you-need-to-know/",
          },

          {
            head: "Which is a better choice for my health, raw nuts, or roasted?",
            body: "https://www.nutritionletter.tufts.edu/food-allergies-sensitivities/q-which-is-a-better-choice-for-my-health-raw-nuts-or-roasted/",
          },

          {
            head: "Add Seeds to Your Healthy Diet",
            body: "https://livesmartcolorado.colostate.edu/add-seeds-to-your-healthy-diet/",
          },

          {
            head: "Are Anti-Nutrients Harmful?",
            body: "https://nutritionsource.hsph.harvard.edu/anti-nutrients/",
          },

          {
            head: "Add Seeds to Your Healthy Diet",
            body: "https://livesmartcolorado.colostate.edu/add-seeds-to-your-healthy-diet/",
          },

          {
            head: "No need to avoid healthy omega-6 fats",
            body: "https://www.health.harvard.edu/newsletter_article/no-need-to-avoid-healthy-omega-6-fats",
          },
        ],
      },
    ],
  },
  {
    id: 14,
    name: "monounsaturated-fats",
    header: "Monounsaturated Fats (MUFA)",
    data: [
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Olive Oil",
          "Avocados",
          "Almonds",
          "Pecans",
          "Pumpkin Seeds",
          "Sesame Seeds",
        ],
      },
      {
        type: "list",
        dataHeader: "Health Benefits",
        content: [
          "Help reduce bad cholesterol levels (LDL)",
          "Lower risk of heart disease and stroke",
          "Provide nutrients to help develop and maintain body cells",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Why do I need to include fat in my diet?",
            body: "https://healthy.ucdavis.edu/eating-well/nourish-labels/healthy-fats",
          },
        ],
      },
    ],
  },
  {
    id: 15,
    name: "polyunsaturated-fats",
    header: "Polyunsaturated Fats (PUFA)",
    data: [
      {
        type: "para",
        dataHeader: "What Are PUFAs?",
        content: [
          "These include essential fats that your body needs but can't produce itself, so they must be obtained through your diet.",
        ],
      },
      {
        type: "heading",
        dataHeader: "Omega-3 Fatty Acids",
        content: "Omega-3 Fatty Acids",
      },
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Salmon",
          "Mackerel",
          "Sardines",
          "Flaxseeds",
          "Flaxseed Oil",
          "Chia Seeds",
          "Walnuts",
        ],
      },
      {
        type: "list",
        dataHeader: "Health Benefits",
        content: [
          "Reduce inflammation",
          "Lower risk of heart disease",
          "Support brain health and development",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Types of Fat",
            body: "https://nutritionsource.hsph.harvard.edu/what-should-you-eat/fats-and-cholesterol/types-of-fat/",
          },
        ],
      },
      {
        type: "heading",
        dataHeader: "Omega-6 Fatty Acids",
        content: "Omega-6 Fatty Acids",
      },
      {
        type: "sources",
        dataHeader: "Examples",
        content: [
          "Safflower Oil",
          "Sunflower Oil",
          "Soybean Oil",
          "Walnuts",
          "Pumpkin Seeds",
        ],
      },
      {
        type: "list",
        dataHeader: "Health Benefits",
        content: [
          "Support skin and hair growth",
          "Maintain bone health",
          "Regulate metabolism",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "No need to avoid healthy omega-6 fats.",
            body: "https://www.health.harvard.edu/newsletter_article/no-need-to-avoid-healthy-omega-6-fats",
          },
        ],
      },
      {
        type: "heading",
        dataHeader: "Balancing Omega-3 and Omega-6",
        content: "Balancing Omega-3 and Omega-6",
      },
      {
        type: "para",
        dataHeader: "Why Balance Matters",
        content: [
          "While both omega-3 and omega-6 fatty acids are essential, it's important to maintain a balanced ratio. Excessive omega-6 intake, common in Western diets, can promote inflammation. Increasing omega-3 intake can help achieve a healthier balance.",
        ],
      },
      {
        type: "link",
        dataHeader: "Source",
        content: [
          {
            head: "Why do I need to include fat in my diet?",
            body: "https://healthy.ucdavis.edu/eating-well/nourish-labels/healthy-fats",
          },
          {
            head: "Essential Fatty Acids",
            body: "https://lpi.oregonstate.edu/mic/other-nutrients/essential-fatty-acids",
          },
        ],
      },
    ],
  },
];

export default cartData;
